import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { quickApplyActions } from '../../redux/slices/quickApplySlice';
import { __t } from '../../../../../base/utils/t';
import { RichTextEditor } from '../../../../../base/components/Forms/RichTextEditor';

export const TextDescription = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { description },
        errors,
    } = useAppSelector((state) => state.workerAppQuickApply);

    const inputChangeHandler = (value: string) => {
        dispatch(quickApplyActions.setField({ id: 'description', value }));
    };

    return (
        <div className='quick-apply-step-form quick-apply-step-form--wide'>
            <div className='quick-apply-step-form__item'>
                <p className='quick-apply-step-form__label'>{__t('Добавьте информацию о себе')}</p>
                <RichTextEditor
                    initialValue={description}
                    onChange={inputChangeHandler}
                    placeholder={`${__t(
                        'Укажите ваш опыт работы и информацию, которая будет полезна для работодателя. К примеру, «Работал строителем 5 лет, знаю польский язык, есть водительские права.»',
                    )}`}
                    maxLength={500}
                    error={errors?.description}
                    className='quick-apply-step-form__textarea'
                />
            </div>
        </div>
    );
};
